import './app.css';
import { customElement } from 'solid-element';
import { Party } from './lib/Party';

// Register the custom element
customElement('solid-party', {
    document: undefined as any,
    template: undefined as any,
    componentDefinition: undefined as any,
    fieldValue: undefined,
    fieldName: '',
    previousFieldValue: '',
    key: 0,
    formParameters: undefined as any,
}, Party);

// Export the component for testing
export { Party };
